import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import {Vue as VueIntegration} from '@sentry/integrations';

Sentry.init({
    dsn: window.App.state.config.sentry.dsn,
    integrations: [new VueIntegration({Vue, attachProps: true})],
    ignoreErrors: ['Non-Error promise rejection captured', 'Navigating to current location']
});
